const SEPARATORS = {
  CHILD: ',',
  ADULT: ',',
  ROOM: '_',
  SEARCH_QUERY: '?',
  QUERY_PARAM: '&',
  KEY_VALUE: '=',
};

const parseArray = (param, separator) => param.split(separator).filter(Boolean);
const getChildComponents = childParam =>
  parseArray(childParam, SEPARATORS.ROOM).map(Number);

export const buildRoomModel = (adult = 1, child = 0, infant = 0) => ({
  adult,
  child,
  infant,
});

export const getRoomOccupancy = (adultsParam, childrenParam) => {
  const adults = parseArray(adultsParam, SEPARATORS.ADULT).map(Number);
  const fullChildren = parseArray(childrenParam, SEPARATORS.CHILD).sort(
    (childA, childB) => {
      const [roomIndexA] = getChildComponents(childA);
      const [roomIndexB] = getChildComponents(childB);

      return roomIndexA - roomIndexB;
    }
  );
  const initialOccupancy = adults.map(adult => buildRoomModel(adult));

  return fullChildren.reduce((result, child, index) => {
    const [roomIndex] = getChildComponents(child);
    const room = result[roomIndex - 1] || buildRoomModel(adults[index] || 0);
    room.child += 1;

    return [
      ...result.slice(0, roomIndex - 1),
      room,
      ...result.slice(roomIndex),
    ];
  }, initialOccupancy);
};

export const getChildAges = childrenParam => {
  const fullChildren = parseArray(childrenParam, SEPARATORS.CHILD).sort(
    (childA, childB) => {
      const [roomIndexA] = getChildComponents(childA);
      const [roomIndexB] = getChildComponents(childB);

      return roomIndexA - roomIndexB;
    }
  );

  const childAgesObj = fullChildren.reduce((result, child, index) => {
    const [roomIndex, age] = getChildComponents(child);
    if (!result[roomIndex]) result[roomIndex] = [];
    result[roomIndex].push({
      value: `${age}`,
    });

    return result;
  }, {});

  let childsAge = [];
  Object.keys(childAgesObj).forEach(k => childsAge.push(childAgesObj[k]));
  return childsAge;
};
